import axios from 'axios'

const URL_GET_StandardRelevantAnalytes = 'api/AdminGuideline/RelevantAnalyte/'

const SetStandardRelevantAnalytes = 'SetStandardRelevantAnalytes'
const ClearStandardRelevantAnalytes = 'ClearStandardRelevantAnalytes'

function initialState() {
  return {
    Guidelines: [],
    guidelinesCategory: [],
    StandardRelevantAnalytes: [],
  }
}

export default {
  namespaced: true,

  state: initialState,

  actions: {
    async getGuidelines({ commit }) {
      try {
        var res = await axios.get('api/Guideline/List')
        var allGuidelines = JSON.parse(JSON.stringify(res.data))
        let sortProperty = 'GuidelineName'
        let dynamicSort = (property) => {
          let sortOrder = 1
          if (property[0] === '-') {
            sortOrder = -1
            property = property.substr(1)
          }
          return (a, b) => {
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
            return result * sortOrder
          }
        }
        allGuidelines = allGuidelines.sort(dynamicSort(sortProperty))
        commit('SET_GUIDELINES', allGuidelines)
      } catch (e) {
        throw 'Could not get guideline data.'
      }
    },
    async putGuidelineConfig({
      commit,
    }, options) {
      try {
        let res = await axios.put('api/AdminGuideline/GuidelineConfig', options.payload)
        options.successCb(res.data)
      } catch (error) {
        options.failedCb(error.message, error)
      }
    },
    async putGuidelineAnalyteDefaultValuesByBatch({
      commit,
    }, options) {
      let validData = options.payload.filter(x => (x && x.AnalyteName && x.Units && x.Value))
      try {
        await Promise.all(validData.map(d => axios.put('api/AdminGuideline/DefaultValue', d)))
        options.successCb()
      } catch (error) {
        options.failedCb(error.message, error)
      }
    },
    async removeGuidelineAnalyteDefaultValue({ commit }, options) {
      try {
        let res = await axios.delete(`api/AdminGuideline/DefaultValue/${options.defaultValueId}`)
        options.successCb(res.data)
      } catch (error) {
        options.failedCb(error.message, error)
      }
    },
    async postAddNewGuideline({ commit }, options) {
      axios.post('api/AdminGuideline/AddGuideline?updateMediaTypeForAllTenants=false', options.data, options.config)
        .then(res => {
          let data = {
            Id: res.data.Id,
            GuidelineName: options.data.Name,
            GuidelineLongName: options.data.LongName,
            Category: options.data.Category,
            Medias: options.data.MediaTypes,
            Standards: [],
            TenantGuidelines: [],
          }
          commit('AddNewGuideline', data)
          options.addSuccessCb(data)
        })
        .catch(error => {
          options.failedCb(error.message)
        })
    },
    async deleteGuideline({
      commit,
    }, options) {
      await axios.delete('api/AdminGuideline/DeleteGuideline/' + options.data.GuidelineId)
        .then(() => {
          let data = {
            Id: options.data.GuidelineId,
          }
          commit('DeleteGuideline', data)
          options.successCb()
        })
        .catch(error => {
          options.failedCb(error.message)
        })
    },
    async postUpdateGuideline({
      commit,
    }, options) {
      axios.post('api/AdminGuideline/UpdateGuideline?updateMediaTypeForAllTenants=false', options.data, options.config)
        .then(res => {
          let data = {
            Id: options.data.Id,
            GuidelineName: options.data.Name,
            GuidelineLongName: options.data.LongName,
            Category: options.data.Category,
            Medias: options.data.MediaTypes,
            Standards: options.data.Standards,
            TenantGuidelines: options.data.TenantGuidelines,
          }
          commit('UpdateGuideline', data)
          options.updateSuccessCb(res)
        })
        .catch(error => {
          options.failedCb(error.message)
        })
    },
    async postAddGuidelineTenant({
      commit,
    }, options) {
      axios.post('api/AdminGuideline/AddTenant', options.data)
        .then(res => {
          let data = {
            Id: options.data.GuidelineId,
            TenantGuidelines: [],
          }
          options.data.Tenants.forEach(element => {
            data.TenantGuidelines.push({
              TenantId: element.TenantId,
              IsEditable: element.IsEditable,
            })
          })
          commit('UpdateGuidelineTenant', data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error.message)
        })
    },
    async postUpdateGuidelineTenant({
      commit,
    }, options) {
      axios.post('api/AdminGuideline/UpdateTenant', options.data)
        .then(res => {
          let data = {
            Id: options.data.GuidelineId,
            TenantGuidelines: [],
          }
          options.data.Tenants.forEach(element => {
            data.TenantGuidelines.push({
              TenantId: element.TenantId,
              IsEditable: element.IsEditable,
            })
          })
          commit('UpdateGuidelineTenant', data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error.message)
        })
    },
    async postUnlinkGuidelineTenant({
      commit,
    }, options) {
      axios.post('api/AdminGuideline/UnlinkTenant', options.data)
        .then(res => {
          let data = {
            Id: options.data.GuidelineId,
            TenantGuidelines: [],
          }
          res.data.Tenants.forEach(element => {
            data.TenantGuidelines.push({
              TenantId: element.TenantId,
              IsEditable: element.IsEditable,
            })
          })
          commit('UpdateGuidelineTenant', data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error.message)
        })
    },
    async postAddGuidelineStandard({
      commit,
    }, options) {
      axios.post('api/AdminGuideline/AddStandard', options.data)
        .then(res => {
          commit('AddGuidelineStandard', res.data)
          options.successCb(res)
        })
        .catch(error => {
          let message
          if (error.response.data.Message && error.response.data.ExceptionMessage) {
            message = `${error.response.data.Message} ${error.response.data.ExceptionMessage}`
          } else if (error.response.data.Message && !error.response.data.ExceptionMessage) {
            message = error.response.data.Message
          } else if (!error.response.data.Message && error.response.data.ExceptionMessage) {
            message = error.response.data.ExceptionMessage
          }
          options.failedCb(message)
        })
    },
    async postUpdateGuidelineStandard({
      commit,
    }, options) {
      axios.post('api/AdminGuideline/UpdateStandard', options.data)
        .then(res => {
          commit('UpdateGuidelineStandard', res.data)
          options.successCb(res)
        })
        .catch(error => {
          let message
          if (error.response.data.Message && error.response.data.ExceptionMessage) {
            message = `${error.response.data.Message} ${error.response.data.ExceptionMessage}`
          } else if (error.response.data.Message && !error.response.data.ExceptionMessage) {
            message = error.response.data.Message
          } else if (!error.response.data.Message && error.response.data.ExceptionMessage) {
            message = error.response.data.ExceptionMessage
          }
          options.failedCb(message)
        })
    },
    async postDeleteGuidelineStandard({
      commit,
    }, options) {
      axios.post('api/AdminGuideline/DeleteStandard/' + options.data.Id)
        .then(res => {
          commit('DeleteGuidelineStandard', options.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error.message)
        })
    },
    async GetGuidelineAnalyteStandardMaps({
      commit,
    }, options) {
      axios.get('api/Guideline/AnalyteStandardMaps/' + options.data.guidelineId + '/' + options.data.tenantId)
        .then(res => {
          options.successCb(res.data)
        })
        .catch(error => {
          options.failedCb(error.message)
        })
    },
    async CheckGuideline({
      commit,
    }, options) {
      axios.get('api/Guideline/DataCheck/' + options.data)
        .then(res => {
          options.successCb(res.data)
        })
        .catch(error => {
          options.failedCb(error.message)
        })
    },
    async StandardValueCheck({
      commit,
    }, options) {
      var url = 'api/AdminGuideline/StandardValueCheck'
      await axios.post(url, options.data)
        .then(res => {
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async GetStandardRelevantAnalytes({ commit }, id) {
      try {
        let res = await axios.get(URL_GET_StandardRelevantAnalytes + id)
        commit(SetStandardRelevantAnalytes, res.data)
      } catch (error) {
        console.error(error)
        commit(ClearStandardRelevantAnalytes)
        throw error.response.data
      }
    },
  },

  mutations: {
    SET_GUIDELINES(state, value) {
      state.Guidelines = value
    },
    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    AddNewGuideline(state, data) {
      var dc = JSON.parse(JSON.stringify(state.Guidelines))
      let arr = []
      data.Medias.forEach(x => {
        let i = {
          IconPath: x.IconPath,
          MediaTypeId: x.Id,
          Name: x.Name,
        }
        arr.push(i)
      })
      data.Medias = arr
      dc.push(data)
      state.Guidelines = dc
    },
    UpdateGuideline(state, data) {
      var dc = JSON.parse(JSON.stringify(state.Guidelines))
      let guideline = dc.find(x => x.Id == data.Id)
      let i = dc.indexOf(guideline)
      let arr = []
      data.Medias.forEach(x => {
        let i = {
          IconPath: x.IconPath,
          MediaTypeId: x.Id,
          Name: x.Name,
        }
        arr.push(i)
      })
      data.Medias = arr
      dc.splice(i, 1, data)
      state.Guidelines = dc
    },
    DeleteGuideline(state, data) {
      var dc = JSON.parse(JSON.stringify(state.Guidelines))
      let guideline = dc.find(x => x.Id == data.Id)
      let i = dc.indexOf(guideline)
      dc.splice(i, 1)
      state.Guidelines = dc
    },
    AddGuidelineTenant(state, data) {
      var dc = JSON.parse(JSON.stringify(state.Guidelines))
      let guideline = dc.find(x => x.Id == data.Id)
      guideline.TenantGuidelines.push(data.TenantGuidelines)
      state.Guidelines = dc
    },
    UpdateGuidelineTenant(state, data) {
      var dc = JSON.parse(JSON.stringify(state.Guidelines))
      let guideline = dc.find(x => x.Id == data.Id)
      let i = dc.indexOf(guideline)
      guideline.TenantGuidelines = data.TenantGuidelines
      dc.splice(i, 1, guideline)
      state.Guidelines = dc
    },
    AddGuidelineStandard(state, data) {
      var dc = JSON.parse(JSON.stringify(state.Guidelines))
      let guideline = dc.find(x => x.Id == data.GuidelineId)
      guideline.Standards.push(data)
      state.Guidelines = dc
    },
    UpdateGuidelineStandard(state, data) {
      var dc = JSON.parse(JSON.stringify(state.Guidelines))
      let guideline = dc.find(x => x.Id == data.GuidelineId)
      let standard = guideline.Standards.find(x => x.Id == data.Id)
      let i = guideline.Standards.indexOf(standard)
      guideline.Standards.splice(i, 1, data)
      state.Guidelines = dc
    },
    DeleteGuidelineStandard(state, data) {
      var dc = JSON.parse(JSON.stringify(state.Guidelines))
      let guideline = dc.find(x => x.Id == data.GuidelineId)
      let standard = guideline.Standards.find(x => x.Id == data.Id)
      let i = guideline.Standards.indexOf(standard)
      guideline.Standards.splice(i, 1)
      state.Guidelines = dc
    },
    [SetStandardRelevantAnalytes](state, data) {
      state.StandardRelevantAnalytes = data
    },
    [ClearStandardRelevantAnalytes](state) {
      state.StandardRelevantAnalytes = []
    },
  },

  getters: {
    Guidelines: state => state.Guidelines,
    guidelinesCategory: state => {
      var category = []
      state.Guidelines.forEach(e => {
        category.push(e.Category)
      })
      return category
    },
    guidelineOfCurrentTenant: (state, getters, rootState, rootGetters) => {
      var currentTenantId = rootGetters['authenticate/currentUserGroup'].id
      var matched = state.Guidelines.filter(x => x.TenantGuidelines.some(t => t.TenantId === currentTenantId))
      return matched
    },
    analyteInGuidelineList: state => {
      var list = []
      state.Guidelines.forEach(element => {
        element.Standards.forEach(item => {
          let analyte = {
            AnalyteNameInGuideline: item.AnalyteNameInGuideline,
            WaterQualityLabAnalyteId: item.WaterQualityLabAnalyteId,
          }
          if (list.indexOf(analyte) == -1) {
            list.push(analyte)
          }
        })
      })
      return list.sort((a, b) => {
        if (a.AnalyteNameInGuideline.toLowerCase() > b.AnalyteNameInGuideline.toLowerCase()) {
          return 1
        }
        return -1
      })
    },
    guidelineDefaultValueByName: state => name => {
      return state.guidelineDefaultValues.data.find(x => x.AnalyteName == name)
    },
    StandardRelevantAnalytes: s => s.StandardRelevantAnalytes,
  },
}